import React, { useState } from "react";
import AllAcceptTable from "../components/applications/table/allaccepttable";
import { Link, useNavigate } from "react-router-dom";
import { useTotalApplications } from "../adapters/Requests";
import { Home, ChevronRight, ArrowLeft } from "lucide-react";
import { PageLoader } from "../components/ui/InlineLoader";

function AllAcceptPage() {
  const total = useTotalApplications();
  const { data, isLoading } = total;
  const [selectedValue, setSelectedValue] = useState("all");
  const navigate = useNavigate();

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  if (isLoading) {
    return <PageLoader text="Loading acceptances..." />;
  }
  if (!data) {
    return <div>No data available</div>;
  }
  return (
    <>
      <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div className="flex items-center justify-between w-full ">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Link
              to="/dashboard"
              className="flex items-center hover:text-green-600 transition-colors"
            >
              <Home size={16} />
            </Link>
            <ChevronRight size={16} className="text-gray-300" />
            <span className="font-semibold text-gray-900">All Acceptances</span>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={16} /> Back
          </button>
        </div>
      </div>

      <div className="flex">
        <span className="relative m-auto mt-6 text-sm lg:text-lg text-gray-500 font-semibold mb-2">
          Filter Applications for Acceptance
        </span>
      </div>

      <main className="">
        <div className="justify-center m-auto align-middle flex"></div>
        <div className=" flex space-x-4 m-auto">
          <AllAcceptTable internship_type={selectedValue} />
        </div>
        <div className="px-2 sm:px-2 lg:px-2 py-2 w-full max-w-9xl mx-auto"></div>
      </main>
    </>
  );
}

export default AllAcceptPage;
